import store from "../store";
const CourtDayOfWeekEnum = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

export const locations = () => store.getState()?.allPreLoadedApis?.locations;
export const generateIntervals = (
  timeslots,
  intervalMinutes = 60,
  originalDuration
) => {
  const intervals = [];
  const intervalMs = intervalMinutes * 60 * 1000; // Convert interval to milliseconds
  // Helper function to convert "HH:mm" to Date object
  function parseTime(time) {
    const [hours, minutes] = time?.split(":")?.map(Number);
    return new Date(0, 0, 0, hours, minutes);
  }
  // Helper function to format Date object to "HH:mm:ss"
  function formatTime(date) {
    return date.toTimeString().slice(0, 8);
  }
  // Generate intervals
  for (const timeslot of timeslots || []) {
    let current = parseTime(timeslot.courtStartTime);
    const end =
      timeslot.courtEndTime == "00:00:00"
        ? new Date(0, 0, 0, 24, 0)
        : parseTime(timeslot.courtEndTime);
    // If you divide by 30-minute intervals, the charge should be halved
    const totalCharge = timeslot.courtCharges; // Charges for the original 1-hour slot
    const chargePerInterval =
      (totalCharge/originalDuration) * intervalMinutes
    while (current < end) {
      const next = new Date(current.getTime() + intervalMs);
      intervals.push({
        ...timeslot,
        courtStartTime: formatTime(current),
        courtEndTime: formatTime(next),
        isBlocked: true, // Default to true
        courtCharges: chargePerInterval, // Set the charge for the interval (either halved or full)
      });
      current = next; // Move to the next interval
    }
  }
  return intervals;
};

export const splitAndMarkBlockedIntervals = (intervals = [], blockedTimes) => {
  // Helper function to convert "HH:mm" to Date object
  function parseTime(time) {
    const [hours, minutes] = time?.split(":").map(Number);
    return new Date(0, 0, 0, hours, minutes);
  }
  // Helper function to format Date object to "HH:mm:ss"
  function formatTime(date) {
    return date.toTimeString()?.slice(0, 8);
  }
  if (blockedTimes) {
    const result = [];
    for (const interval of intervals) {
      let { courtStartTime, courtEndTime } = interval;
      const intervalStart = parseTime(courtStartTime);
      const intervalEnd =
        courtEndTime == "00:00:00"
          ? new Date(0, 0, 0, 24, 0)
          : parseTime(courtEndTime);

      // Find overlapping blocked times
      const overlappingBlocked = blockedTimes?.filter((blocked) => {
        const blockedStart = parseTime(blocked.blockedStartTime);
        const blockedEnd =
          blocked.blockedEndTime == "00:00:00"
            ? new Date(0, 0, 0, 24, 0)
            : parseTime(blocked.blockedEndTime);
        return (
          (intervalStart < blockedEnd && intervalEnd > blockedStart) || // Partial overlap
          (intervalStart >= blockedStart && intervalEnd <= blockedEnd) // Fully contained
        );
      });

      if (overlappingBlocked?.length > 0) {
        const intervalStart = parseTime(interval.courtStartTime);
        const intervalEnd = interval.courtEndTime === "00:00:00"
          ? new Date(0, 0, 0, 24, 0)
          : parseTime(interval.courtEndTime);

        // Step 1: Combine overlapping blocks into one overall blocked window
        let blockStart = parseTime("23:59:59");
        let blockEnd = new Date(0, 0, 0, 0, 0);

        overlappingBlocked.forEach(block => {
          const start = parseTime(block.blockedStartTime);
          const end = block.blockedEndTime === "00:00:00"
            ? new Date(0, 0, 0, 24, 0)
            : parseTime(block.blockedEndTime);

          if (start < blockStart) blockStart = start;
          if (end > blockEnd) blockEnd = end;
        });

        const fullyCovered = intervalStart >= blockStart && intervalEnd <= blockEnd;

        if (fullyCovered) {
          result?.push({
            ...interval,
            isBlocked: true,
          });
        } else if (intervalStart < blockStart) {
          const slotDuration = (blockStart - intervalStart) / (60 * 1000); // Convert milliseconds to minutes
          if (slotDuration >= 30) {
            let wastedBlock = new Date(intervalStart);
            wastedBlock.setMinutes(intervalStart.getMinutes() + 30);
            result?.push({
              ...interval,
              courtStartTime: formatTime(intervalStart),
              courtEndTime: formatTime(wastedBlock),
              courtCharges: interval?.courtCharges / 2,
              isBlocked: false,
            });
            result?.push({
              ...interval,
              courtStartTime: formatTime(wastedBlock),
              courtCharges: interval?.courtCharges / 2,
              courtEndTime: formatTime(intervalEnd),
            });
          } else {
            result?.push({
              ...interval,
            });
          }
        } else if (blockEnd < intervalEnd) {
          const slotDuration = (intervalEnd - blockEnd) / (60 * 1000);
          if (slotDuration >= 30) {
            let wastedBlock = new Date(intervalStart);
            wastedBlock.setMinutes(intervalStart.getMinutes() + 30);
            result?.push({
              ...interval,
              courtStartTime: formatTime(intervalStart),
              courtEndTime: formatTime(wastedBlock),
              courtCharges: interval?.courtCharges / 2,
            });
            result?.push({
              ...interval,
              courtStartTime: formatTime(wastedBlock),
              courtEndTime: formatTime(intervalEnd),
              courtCharges: interval?.courtCharges / 2,
              isBlocked: false,
            });
          } else {
            result?.push({
              ...interval,
            });
          }
        } else {
          result?.push({
            ...interval,
          });
        }
      } else {
        result?.push({
          ...interval,
          isBlocked: false,
        });
      }
    }
    return result;
  } else {
    return intervals;
  }
};

export const getRelatedCourts = (selectedLocation) => {
  console.log("store", selectedLocation);
  return (
    locations()
      ?.find((location) => location?.locationId === selectedLocation)
      ?.courts?.map((court) => ({
        label: court?.courtName,
        value: court?.courtId,
        ...court,
      })) || []
  );
};
export const getSelectedCourt = (selectedLocation, selectedCourt) => {
  console.log("Locations");
  return (
    locations()
      ?.find((location) => location?.locationId === selectedLocation)
      ?.courts?.find((court) => court?.courtId === selectedCourt) || null
  );
};
export const getCourtTimings = (
  selectedLocation,
  selectedCourt,
  courtDayOfWeek
) => {
  return (
    locations()
      ?.find((location) => location?.locationId === selectedLocation)
      ?.courts?.find((court) => court?.courtId === selectedCourt)
      ?.courtTimings?.filter(
        (courtTime) => courtTime?.courtDayOfWeek === courtDayOfWeek
      ) || null
  );
};

export const dayOfWeek = (date) => {
  return new Date(date).getDay();
};
